import React, { useEffect } from 'react'
import userContext from '../context/Users/UserContext';
import { useContext } from 'react';


const Homepage = () => {

  const context = useContext(userContext);
  const {setisauthenticated} = context

  let token = localStorage.getItem("token")

  useEffect(() => {
    if (token) {
      setisauthenticated(true)
    }
  }, [])


  return (
    <div className="container my-5 border shadow text-center" style={{width:"90%"}}>
      <h1>Welcome To EverFloat Notes-notes on cloud</h1>
    </div>
  )
}

export default Homepage